import axiosInstance from "./axiosInstance";

// GET /api/posts/{postId}/comments/
export const getComments = async (postId) => {
  const response = await axiosInstance.get(`/posts/${postId}/comments/`);
  return response.data?.results || response.data || [];
};

// POST /api/posts/{postId}/comments/
export const postComment = async (postId, content, parentId = null) => {
  const response = await axiosInstance.post(`/posts/${postId}/comments/`, {
    content,
    parent: parentId, // ✅ null = top level, id = reply
  });
  return response.data;
};

// DELETE /api/posts/{postId}/comments/{commentId}/
export const deleteComment = async (postId, commentId) => {
  const response = await axiosInstance.delete(
    `/posts/${postId}/comments/${commentId}/`
  );
  return response.data;
};